<template>
  <orderPage :type="'delete'"></orderPage>
</template>

<script>
import orderPage from "../order-template/index.vue";
export default {
  name: "deleteOrder",
  components: {
    orderPage
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
